module.exports = __webpack_public_path__ + "img/MURAL_SLIDE_5.f6b1bf39.png";